"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.ERC721MultiCollectionUpgradeable__factory = void 0;
var ethers_1 = require("ethers");
var _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "root",
                type: "bytes32"
            },
        ],
        name: "AddRoot",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            },
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "root",
                type: "bytes32"
            },
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "proofs",
                type: "bytes32[]"
            },
            {
                indexed: false,
                internalType: "address",
                name: "creator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "string",
                name: "uri",
                type: "string"
            },
        ],
        name: "ClaimToken",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "MintToken",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address"
            },
        ],
        name: "OwnershipTransferred",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract IERC20",
                name: "payToken",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
        ],
        name: "Payment",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint64",
                name: "time",
                type: "uint64"
            },
        ],
        name: "SetClose",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "uri",
                type: "string"
            },
        ],
        name: "SetContractURI",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint64",
                name: "time",
                type: "uint64"
            },
        ],
        name: "SetOpen",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                components: [
                    {
                        internalType: "contract IERC20",
                        name: "payToken",
                        type: "address"
                    },
                    {
                        internalType: "uint256",
                        name: "price",
                        type: "uint256"
                    },
                    {
                        internalType: "uint64",
                        name: "open",
                        type: "uint64"
                    },
                    {
                        internalType: "uint64",
                        name: "close",
                        type: "uint64"
                    },
                    {
                        internalType: "string",
                        name: "uri",
                        type: "string"
                    },
                ],
                indexed: false,
                internalType: "struct CollectionWrapper.Param",
                name: "param",
                type: "tuple"
            },
        ],
        name: "SetParam",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract IERC20",
                name: "payToken",
                type: "address"
            },
        ],
        name: "SetPayToken",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "price",
                type: "uint256"
            },
        ],
        name: "SetPrice",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "root",
                type: "bytes32"
            },
        ],
        name: "addRoot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "root",
                type: "bytes32"
            },
            {
                internalType: "string",
                name: "uri",
                type: "string"
            },
            {
                internalType: "address",
                name: "creator",
                type: "address"
            },
            {
                internalType: "bytes32[]",
                name: "proofs",
                type: "bytes32[]"
            },
        ],
        name: "claim",
        outputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "root",
                type: "bytes32"
            },
            {
                internalType: "string",
                name: "uri",
                type: "string"
            },
            {
                internalType: "address",
                name: "creator",
                type: "address"
            },
            {
                internalType: "bytes32[]",
                name: "proofs",
                type: "bytes32[]"
            },
        ],
        name: "claimAndMint",
        outputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "close",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address"
            },
            {
                internalType: "string",
                name: "name",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string"
            },
            {
                internalType: "bytes32",
                name: "root",
                type: "bytes32"
            },
            {
                internalType: "contract MintBoxPool",
                name: "pool",
                type: "address"
            },
            {
                components: [
                    {
                        internalType: "contract IERC20",
                        name: "payToken",
                        type: "address"
                    },
                    {
                        internalType: "uint256",
                        name: "price",
                        type: "uint256"
                    },
                    {
                        internalType: "uint64",
                        name: "open",
                        type: "uint64"
                    },
                    {
                        internalType: "uint64",
                        name: "close",
                        type: "uint64"
                    },
                    {
                        internalType: "string",
                        name: "uri",
                        type: "string"
                    },
                ],
                internalType: "struct CollectionWrapper.Param",
                name: "param",
                type: "tuple"
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key_",
                type: "bytes32"
            },
        ],
        name: "isClaimed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "isClosed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "isLimited",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "key_",
                type: "bytes32"
            },
        ],
        name: "isMinted",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "isNeverClosed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "isOpen",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "root",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "proofs",
                type: "bytes32[]"
            },
            {
                internalType: "address",
                name: "creator_",
                type: "address"
            },
            {
                internalType: "string",
                name: "uri",
                type: "string"
            },
        ],
        name: "isValid",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "root",
                type: "bytes32"
            },
            {
                internalType: "bytes32[]",
                name: "proofs",
                type: "bytes32[]"
            },
            {
                internalType: "address",
                name: "creator_",
                type: "address"
            },
            {
                internalType: "string",
                name: "uri",
                type: "string"
            },
        ],
        name: "key",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "mint",
        outputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "open",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "param",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "payToken",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "price",
                type: "uint256"
            },
            {
                internalType: "uint64",
                name: "open",
                type: "uint64"
            },
            {
                internalType: "uint64",
                name: "close",
                type: "uint64"
            },
            {
                internalType: "string",
                name: "uri",
                type: "string"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "payToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "pool",
        outputs: [
            {
                internalType: "contract MintBoxPool",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "price",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "root",
                type: "bytes32"
            },
        ],
        name: "rootExists",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes"
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "time",
                type: "uint64"
            },
        ],
        name: "setClose",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "contractURI_",
                type: "string"
            },
        ],
        name: "setContractURI",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "time",
                type: "uint64"
            },
        ],
        name: "setOpen",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "contract IERC20",
                        name: "payToken",
                        type: "address"
                    },
                    {
                        internalType: "uint256",
                        name: "price",
                        type: "uint256"
                    },
                    {
                        internalType: "uint64",
                        name: "open",
                        type: "uint64"
                    },
                    {
                        internalType: "uint64",
                        name: "close",
                        type: "uint64"
                    },
                    {
                        internalType: "string",
                        name: "uri",
                        type: "string"
                    },
                ],
                internalType: "struct CollectionWrapper.Param",
                name: "_param",
                type: "tuple"
            },
        ],
        name: "setParam",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "contract IERC20",
                name: "payToken_",
                type: "address"
            },
        ],
        name: "setPayToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "price_",
                type: "uint256"
            },
        ],
        name: "setPrice",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "timestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256"
            },
        ],
        name: "tokenByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            },
        ],
        name: "tokenIds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256"
            },
        ],
        name: "tokenOfOwnerByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        name: "tokens",
        outputs: [
            {
                internalType: "address",
                name: "creator",
                type: "address"
            },
            {
                internalType: "string",
                name: "uri",
                type: "string"
            },
            {
                internalType: "uint8",
                name: "status",
                type: "uint8"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address"
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256"
            },
        ],
        name: "valueOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
];
var _bytecode = "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";
var ERC721MultiCollectionUpgradeable__factory = /** @class */ (function (_super) {
    __extends(ERC721MultiCollectionUpgradeable__factory, _super);
    function ERC721MultiCollectionUpgradeable__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (args.length === 1) {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        else {
            _this = _super.apply(this, args) || this;
        }
        return _this;
    }
    ERC721MultiCollectionUpgradeable__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    ERC721MultiCollectionUpgradeable__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    ERC721MultiCollectionUpgradeable__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ERC721MultiCollectionUpgradeable__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ERC721MultiCollectionUpgradeable__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    ERC721MultiCollectionUpgradeable__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    ERC721MultiCollectionUpgradeable__factory.bytecode = _bytecode;
    ERC721MultiCollectionUpgradeable__factory.abi = _abi;
    return ERC721MultiCollectionUpgradeable__factory;
}(ethers_1.ContractFactory));
exports.ERC721MultiCollectionUpgradeable__factory = ERC721MultiCollectionUpgradeable__factory;
